export default __webpack_public_path__ + "static/media/send.2a9d8a44.svg";